/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent,
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    acptNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    acptDtlNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    linkAcptNo?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    orderConfirmContents?: JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContent;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    tel?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    businessHourTitle1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    businessHour1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    businessHourTitle2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse
     */
    businessHour2?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acptNo': !exists(json, 'acptNo') ? undefined : json['acptNo'],
        'acptDtlNo': !exists(json, 'acptDtlNo') ? undefined : json['acptDtlNo'],
        'linkAcptNo': !exists(json, 'linkAcptNo') ? undefined : json['linkAcptNo'],
        'orderConfirmContents': !exists(json, 'orderConfirmContents') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentFromJSON(json['orderConfirmContents']),
        'tel': !exists(json, 'tel') ? undefined : json['tel'],
        'businessHourTitle1': !exists(json, 'businessHourTitle1') ? undefined : json['businessHourTitle1'],
        'businessHour1': !exists(json, 'businessHour1') ? undefined : json['businessHour1'],
        'businessHourTitle2': !exists(json, 'businessHourTitle2') ? undefined : json['businessHourTitle2'],
        'businessHour2': !exists(json, 'businessHour2') ? undefined : json['businessHour2'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acptNo': value.acptNo,
        'acptDtlNo': value.acptDtlNo,
        'linkAcptNo': value.linkAcptNo,
        'orderConfirmContents': JpCoBenefitoneBsdpBffPresentationResponseOrderConfirmNoPaymentPostResponseOrderConfirmContentToJSON(value.orderConfirmContents),
        'tel': value.tel,
        'businessHourTitle1': value.businessHourTitle1,
        'businessHour1': value.businessHour1,
        'businessHourTitle2': value.businessHourTitle2,
        'businessHour2': value.businessHour2,
    };
}

